export const min = (values: number[]): number => {
  const minValue = Math.min(...values);
  return minValue;
};
